import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DatePicker } from '@/components/ui/date-picker';
import { usePurchaseOrderMainDate } from './hooks/use-purchase-order-main-date';

type PurchaseOrderMainDateProps = {
  purchaseOrderId: string;
};

export function PurchaseOrderMainDate({
  purchaseOrderId,
}: PurchaseOrderMainDateProps) {
  const { t } = useTranslation('purchaseOrder');
  const {
    dates,
    disabledDates,
    handleDateChange,
    validationErrorKey,
    validationErrorParams,
  } = usePurchaseOrderMainDate(purchaseOrderId);

  const errorMessage = validationErrorKey
    ? t(validationErrorKey, validationErrorParams)
    : null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('cardOrderDate')}</CardTitle>
      </CardHeader>
      <CardContent>
        {errorMessage ? (
          <p className='mb-4 text-destructive text-sm'>{errorMessage}</p>
        ) : null}
        <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
          <DatePicker
            disabled={disabledDates.eop}
            label={t('orderDateEop')}
            onChange={handleDateChange('eop')}
            placeholder={t('orderDatePlaceholder')}
            value={dates.eop}
          />
          <DatePicker
            disabled={disabledDates.etd}
            label={t('orderDateEtd')}
            onChange={handleDateChange('etd')}
            placeholder={t('orderDatePlaceholder')}
            value={dates.etd}
          />
          <DatePicker
            disabled={disabledDates.eta}
            label={t('orderDateEta')}
            onChange={handleDateChange('eta')}
            placeholder={t('orderDatePlaceholder')}
            value={dates.eta}
          />
          <DatePicker
            disabled={disabledDates.lis}
            label={t('orderDateLis')}
            onChange={handleDateChange('lis')}
            placeholder={t('orderDatePlaceholder')}
            value={dates.lis}
          />
        </div>
      </CardContent>
    </Card>
  );
}
